import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// When visiting the contacts index with ?open_modal=new_contact (e.g. from spotlight),
// loads the new-contact form into the contact_modal frame so the modal opens in context.
export default class extends Controller {
  static values = {
    newContactUrl: String
  }

  connect() {
    const params = new URLSearchParams(window.location.search)
    if (params.get("open_modal") !== "new_contact" || !this.newContactUrlValue) {
      return
    }

    this.cleanUrl()
    Turbo.visit(this.newContactUrlValue, { frame: "contact_modal" })
  }

  cleanUrl() {
    const url = new URL(window.location.href)
    url.searchParams.delete("open_modal")
    const clean = url.pathname + (url.search ? url.search : "") + url.hash
    window.history.replaceState(window.history.state, "", clean)
  }
}
